module Pki {
    export enum ErrorType {
        Undefined = -1,
        Sucess = 0,
        InvalidKeypair = 1,
        MissingCommonName = 2,
        EncryptedPrivateKeyInvalid = 3,
        WrongCertificateEncoding = 4,
        CertificateWrappingFailed = 5,
        MissingCertificate = 6,
        EncryptedPrivateKeyInvalidPassword = 7,
        EncryptedPrivateKeyInvalidPrivateKeyNotMatchWithCertificate = 8,
    }
}